import { faFacebookF, faVk } from '@fortawesome/fontawesome-free-brands'
export const general = {
  phone: {
    number: '+49 1747 1827 92',
    href: 'tel:491747182792'
  },
  email: 'stdammit@gmail.com',
  social: {
    facebook: {
      username: 'ValeryAligorsky',
      icon: faFacebookF,
    },
    vk: {
      username: 'stdammit',
      icon: faVk,
    }
  }
}